(function (global) {
  'use strict';

  if (global.SwishCBHardwoodProductPreviews) {
    global.SwishCBHardwoodProductPreviews.init(document);
    return;
  }

  var roots = new Set();
  var originalColors = { 1: '#F1E4CD', 2: '#F1E5D3', 3: '#E9DCCF' };
  var surfaceKeys = ['cm', 'ck', 'cb', 'ce'];
  var staleCoverAttributes = [
    'data-swishcb-cover-src', 'data-swishcb-cover-srcset', 'data-swishcb-cover-sizes',
    'data-swishcb-cover-width', 'data-swishcb-cover-height', 'data-swishcb-cover-loading',
    'data-swishcb-cover-fetchpriority'
  ];

  function seriesFromTitle(value) {
    var match = String(value || '').trim().match(/^(?:hardwood\s*)?l([123])(?:\b|\s|\/)/i);
    return match ? Number(match[1]) : null;
  }

  function originalColor(series) {
    var hardwood = global.SwishCBHardwood;
    if (hardwood && typeof hardwood.getDefaultColor === 'function') {
      return hardwood.getDefaultColor(series === 1 ? 'hardwood' : 'hardwood' + series);
    }
    return originalColors[series];
  }

  function selectedSurfaceHash(hash, series, color) {
    if (!hash || hash.indexOf('swishcb=') !== 0) return hash;
    var seen = {};
    var parts = hash.split('&').map(function (part) {
      var key = part.split('=')[0];
      if (surfaceKeys.indexOf(key) !== -1) {
        seen[key] = true;
        return key + '=' + color;
      }
      if (key === 'cl') {
        seen[key] = true;
        return 'cl=#000000';
      }
      if (key === 'hw' || key === 'hwv') {
        seen[key] = true;
        return key + '=' + (key === 'hw' ? 1 : series);
      }
      if (key === 't') return 't=0';
      return part;
    });
    surfaceKeys.concat(['hw', 'hwv']).forEach(function (key) {
      if (!seen[key]) parts.push(key + '=' + (key === 'hw' ? 1 : (key === 'hwv' ? series : color)));
    });
    if (!seen.cl) parts.push('cl=#000000');
    return parts.join('&');
  }

  function setRuntimeFlags(node) {
    if (!node) return;
    node.setAttribute('data-swishcb-hardwood-product-preview', '1');
    node.setAttribute('data-swishcb-preserve-palette', '1');
    node.setAttribute('data-swishcb-runtime-poster', '1');
    node.setAttribute('data-swishcb-disable-static-cover', '1');
    staleCoverAttributes.forEach(function (name) { node.removeAttribute(name); });
  }

  function productInfo(root) {
    return document.querySelector('product-info[id^="MainProduct-"][data-product-id="' + root.getAttribute('data-swishcb-product-id') + '"]');
  }

  function applySeries(root, series) {
    if (!originalColors[series]) return false;
    var color = originalColor(series);
    var changed = false;
    root.querySelectorAll('[data-swishcb-hardwood-product-preview][data-swishcb-hash]').forEach(function (tile) {
      var previousHash = tile.getAttribute('data-swishcb-hash');
      var nextHash = selectedSurfaceHash(previousHash, series, color);
      setRuntimeFlags(tile);
      setRuntimeFlags(tile.closest('[data-swishcb-preview-config]'));
      if (previousHash !== nextHash) {
        changed = true;
        tile.setAttribute('data-swishcb-hash', nextHash);
        tile.querySelectorAll('[data-swishcb-cover], [data-swishcb-snapshot]').forEach(function (image) {
          image.removeAttribute('src');
          image.removeAttribute('srcset');
        });
      }
    });
    root.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      var marker = href.indexOf('#swishcb=');
      if (marker < 0) return;
      var previousHash = href.slice(marker + 1);
      var nextHash = selectedSurfaceHash(previousHash, series, color);
      if (nextHash !== previousHash) {
        changed = true;
        link.setAttribute('href', href.slice(0, marker + 1) + nextHash);
      }
    });
    root.setAttribute('data-swishcb-hardwood-variant', String(series));
    root.setAttribute('data-swishcb-hardwood-color', color);
    if (changed && global.SwishCB && global.SwishCB.previews && typeof global.SwishCB.previews.init === 'function') {
      global.SwishCB.previews.init();
    }
    return changed;
  }

  function variantForUrl(root) {
    var controller = root._swishcbHardwoodProductController;
    var variantId = new URL(global.location.href).searchParams.get('variant');
    var selected = controller.variants.find(function (variant) { return String(variant.id) === variantId; });
    return selected || controller.variants.find(function (variant) {
      return String(variant.id) === root.getAttribute('data-swishcb-default-variant-id');
    }) || controller.variants[0];
  }

  function synchronizePicker(root, variant) {
    var info = productInfo(root);
    var picker = info && info.querySelector('variant-selects');
    if (!picker || !variant) return;
    var option = variant.option1 || variant.title;
    var input = Array.prototype.find.call(picker.querySelectorAll('input[type="radio"]'), function (radio) {
      return radio.value === option;
    });
    if (input) {
      if (input.checked) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var select = Array.prototype.find.call(picker.querySelectorAll('select'), function (dropdown) {
      return Array.prototype.some.call(dropdown.options, function (candidate) { return candidate.value === option; });
    });
    if (select && select.value !== option) {
      select.value = option;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function pickerSeries(root) {
    var info = productInfo(root);
    var picker = info && info.querySelector('variant-selects');
    if (!picker) return null;
    var checked = Array.prototype.find.call(picker.querySelectorAll('input[type="radio"]'), function (radio) {
      return radio.checked && seriesFromTitle(radio.value);
    });
    if (checked) return seriesFromTitle(checked.value);
    var dropdown = Array.prototype.find.call(picker.querySelectorAll('select'), function (select) {
      return seriesFromTitle(select.value);
    });
    return dropdown ? seriesFromTitle(dropdown.value) : null;
  }

  function restoreFromUrl(root, restorePicker) {
    var variant = variantForUrl(root);
    if (!variant) return;
    applySeries(root, seriesFromTitle(variant.option1 || variant.title));
    if (restorePicker) synchronizePicker(root, variant);
  }

  function initialize(root) {
    if (!root || root._swishcbHardwoodProductController) return;
    var data = root.querySelector('[data-swishcb-hardwood-product-variants]');
    var variants;
    try { variants = JSON.parse(data && data.textContent || '[]'); } catch (_) { return; }
    if (!Array.isArray(variants) || !variants.length) return;
    root._swishcbHardwoodProductController = { variants: variants };
    roots.add(root);
    var initial = variants.find(function (variant) {
      return String(variant.id) === root.getAttribute('data-swishcb-initial-variant-id');
    });
    applySeries(root, seriesFromTitle(initial && (initial.option1 || initial.title)) || Number(root.getAttribute('data-swishcb-hardwood-variant')));
  }

  function eachRoot(callback) {
    roots.forEach(function (root) {
      if (!root.isConnected) roots.delete(root);
      else callback(root);
    });
  }

  function initializeAll(scope) {
    if (scope && scope.matches && scope.matches('[data-swishcb-hardwood-product-previews]')) initialize(scope);
    var search = scope && scope.querySelectorAll ? scope : document;
    search.querySelectorAll('[data-swishcb-hardwood-product-previews]').forEach(initialize);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest || !target.closest('variant-selects')) return;
    var info = target.closest('product-info');
    if (!info) return;
    eachRoot(function (root) {
      if (productInfo(root) === info) applySeries(root, seriesFromTitle(target.value));
    });
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data || {};
      if (!data.variant) return;
      eachRoot(function (root) {
        var info = productInfo(root);
        if (info && info.getAttribute('data-section') === String(data.sectionId)) {
          var series = seriesFromTitle(data.variant.option1 || data.variant.title);
          var selected = pickerSeries(root);
          if (!selected || selected === series) applySeries(root, series);
        }
      });
    });
  }
  global.addEventListener('popstate', function () { eachRoot(function (root) { restoreFromUrl(root, true); }); });
  global.addEventListener('pageshow', function (event) {
    if (event.persisted) eachRoot(function (root) { restoreFromUrl(root, true); });
  });
  global.addEventListener('swishcb:hardwood-ready', function () {
    eachRoot(function (root) { applySeries(root, Number(root.getAttribute('data-swishcb-hardwood-variant'))); });
  });
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    roots.forEach(function (root) {
      if (root === event.target || event.target.contains(root)) {
        roots.delete(root);
        delete root._swishcbHardwoodProductController;
      }
    });
  });
  global.SwishCBHardwoodProductPreviews = { init: initializeAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeAll(document); }, { once: true });
  else initializeAll(document);
})(window);
